import { AssetIcon } from 'assets/icons/AssetIcon';
import TimerText from 'components/timer-text/TimerText';
import Typography from 'components/typography/Typography';
import { TYPOGRAPHY_VARIANTS } from 'components/typography/typography-utils';
import { I18nNamespace } from 'constants/i18n.const';
import { SHOOTING_TYPES } from 'constants/photo.const';
import { useSoundContext } from 'context/SoundContext';
import { useNewPhotoLifeCycleStep } from 'hooks/useNewPhotoLifeCycleStep';
import { usePageTimer } from 'hooks/usePageTimer';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { camerasApi } from 'store/api/camera.slice-api';
import { photoTakenApi } from 'store/api/photo-taken.slice-api';
import { setSelfeAppStateAction } from 'store/features/app/selfeAppSlice';
import { setTrackingStateAction } from 'store/features/app/trackingSlice';
import { useAppDispatch } from 'store/store-hooks';
import './shooting-mode.css';

function ShootingMode() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation([I18nNamespace.COMMON, I18nNamespace.PAGE]);
  const navigate = useNavigate();
  const { audio } = useSoundContext();
  const { getNextPath } = useNewPhotoLifeCycleStep();

  const { second } = usePageTimer({
    forwardFunc: () => handleRedirectSelectLayout(SHOOTING_TYPES.COUNTDOWN)(),
  });

  const handleRedirectSelectLayout = (id: number) => async () => {
    audio?.playContinueClick?.();
    dispatch(setSelfeAppStateAction({ shootingModeId: id }));
    navigate(getNextPath() || '');
  };

  // Start live view
  React.useEffect(() => {
    dispatch(setTrackingStateAction({ LastStartTimeTakePhoto: new Date() }));
    dispatch(camerasApi.util.invalidateTags([{ type: 'Camera' }]));
    dispatch(photoTakenApi.util.invalidateTags([{ type: 'PhotoTaken' }]));
  }, [dispatch]);

  return (
    <>
      <div className="shooting-mode">
        <TimerText second={second} />
        <div className="shooting-mode__btn-group">
          <button
            type="button"
            className="shooting-mode__btn"
            onClick={handleRedirectSelectLayout(SHOOTING_TYPES.COUNTDOWN)}
          >
            <div className="shooting-mode__title-wrapper">
              <Typography variant={TYPOGRAPHY_VARIANTS.H2} firstCapCase>
                {t('page:byCountdown')}
              </Typography>
            </div>
            <div className="shooting-mode__image-wrapper">
              <AssetIcon.OClockCountdownIcon />
            </div>
          </button>
          <button
            type="button"
            className="shooting-mode__btn"
            onClick={handleRedirectSelectLayout(SHOOTING_TYPES.BY_REMOTE)}
          >
            <div className="shooting-mode__title-wrapper">
              <Typography variant={TYPOGRAPHY_VARIANTS.H2} firstCapCase>
                {t('page:byRemote')}
              </Typography>
            </div>
            <div className="shooting-mode__image-wrapper">
              <AssetIcon.RemoteControlIcon />
            </div>
          </button>
        </div>
      </div>
    </>
  );
}

export default ShootingMode;
